import React from "react";
import { Container } from "react-bootstrap";
import { BsBriefcase } from "react-icons/bs";
import {
  FaCode,
  FaLaptopCode,
  FaServer,
  FaChalkboardTeacher,
  FaGithub,
  FaCodeBranch,
} from "react-icons/fa";
import "./Experience.css";

const internshipExperiences = [
  {
    company: "Talendy",
    role: "Software Development Engineer",
    type: "Remote",
    duration: "Aug 2026 – Present",
    icon: <FaServer className="experience-icon" />,
    highlights: [
      "Built data management workflows with validation, synchronization & migration logic, ensuring consistent data across interconnected systems.",
      "Developed and optimized backend workflows with automation, scheduled jobs, API safeguards & production fixes, improving reliability and scalability.",
    ],
    accent: "#0891b2",
  },
  {
    company: "Talendy",
    role: "Software Development Engineer Intern",
    type: "Remote",
    duration: "Nov 2025 – July 2026",
    icon: <FaCode className="experience-icon" />,
    highlights: [
      "Engineered backend APIs with rate limiting, async processing & cron workflows, improving reliability & preventing event loop blocking.",
      "Designed AI‑driven news ingestion pipeline with structured APIs & DB workflows, enabling real‑time processing and notifications.",
    ],
    accent: "#06b6d4",
  },
  {
    company: "Iabsis",
    role: "Software Development Engineer Intern",
    type: "Remote",
    duration: "June 2025 – Sept 2025",
    icon: <FaServer className="experience-icon" />,
    highlights: [
      "Architected a scalable practitioner scheduling system handling 1k+ monthly consultations, reducing operational load by 60%.",
      "Delivered profile management modules, scalable CSV export pipelines, & automated WhatsApp reminder workflows, cutting manual entry by 40%, raising data accuracy to 85%, & increasing overall platform engagement by 35% across critical product journeys.",
    ],
    accent: "#3b82f6",
  },
  {
    company: "Girlscript",
    role: "Software Development Engineer Intern",
    type: "Remote",
    duration: "Sept 2024 – Nov 2024",
    icon: <FaLaptopCode className="experience-icon" />,
    highlights: [
      "Led frontend & backend systems for the GSSoC site, optimizing performance by 40%, refining load times, & elevating UX.",
      "Built contributor cards & a scalable leaderboard for 2k+ developers, improving visibility & boosting contributor engagement by 50%.",
    ],
    accent: "#8b5cf6",
  },
  {
    company: "Timechain Labs",
    role: "Software Development Engineer Intern",
    type: "Remote",
    duration: "Aug 2024 – Oct 2024",
    icon: <BsBriefcase className="experience-icon" />,
    highlights: [
      "Created MVP blockchain explorer, integrating smart contracts to automate workflows, securely processing 50+ transactions/week.",
      "Developed backend APIs to query, search, & analyze 200+ blocks/transactions with pagination, indexing, & streamlined data retrieval.",
    ],
    accent: "#ec4899",
  },
  {
    company: "Concetto Media",
    role: "Software Development Engineer Intern",
    type: "Remote",
    duration: "July 2023 – Sept 2023",
    icon: <FaChalkboardTeacher className="experience-icon" />,
    highlights: [
      "Implemented scalable backend APIs, optimized database queries, & managed 1k+ daily transactions for improved performance.",
      "Designed intuitive UI layouts, enhanced trading platform usability, & increased engagement for 500+ daily users by 25%.",
    ],
    accent: "#f59e0b",
  },
];

const openSourceExperiencesData = [
  {
    company: "Open Source Contributor",
    // role: "Open Source Contributor/Mentor",
    type: "Remote",
    duration: "Oct 2023 - Present",
    icon: <FaCodeBranch className="experience-icon" />,
    highlights: [
      "Built scalable Web3 & GovTech systems under PLDG & C4GT‑DMP'25, delivering production infra & earning Filecoin grant support.",
      "Contributed 220+ PRs across OSS & CNCF projects like Kyverno, Antrea, WasmEdge, improving API performance & system stability.",
    ],
    accent: "#22c55e",
  },
  {
    company: "Code for GovTech (C4GT)",
    role: "Open Source Contributor",
    type: "Remote",
    duration: "June 2025 - Aug 2025",
    icon: <FaCodeBranch className="experience-icon" />,
    highlights: [
      "Worked on impactful government technology projects, contributing to public digital infrastructure.",
    ],
    accent: "#22c55e",
  },
  {
    company: "Social Summer of Code",
    role: "Open Source Mentor",
    type: "Remote",
    duration: "Jun 2025 - Aug 2025",
    icon: <FaChalkboardTeacher className="experience-icon" />,
    highlights: [
      "Led and mentored teams of students, facilitating their contributions to open-source software for social good.",
    ],
    accent: "#f43f5e",
  },
  {
    company: "Protocol Labs",
    role: "Open Source Contributor",
    type: "Remote",
    duration: "Jan 2025 - Apr 2025",
    icon: <FaCode className="experience-icon" />,
    highlights: [
      "Contributed to projects related to decentralized storage and web3 technologies, enhancing protocol functionalities.",
    ],
    accent: "#0ea5e9",
  },
  {
    company: "Social Winter of Code",
    role: "Open Source Mentor",
    type: "Remote",
    duration: "Jan 2025 - Mar 2025",
    icon: <FaChalkboardTeacher className="experience-icon" />,
    highlights: [
      "Mentored students in various open-source projects, focusing on community building and technical guidance.",
    ],
    accent: "#d946ef",
  },
  {
    company: "GirlScript Summer of Code Extd (GSSoC'24 Extd)",
    role: "Open Source Mentor",
    type: "Remote",
    duration: "Oct 2024 - Nov 2024",
    icon: <FaChalkboardTeacher className="experience-icon" />,
    highlights: [
      "Guided and mentored participants, reviewed pull requests, and fostered a collaborative learning environment.",
    ],
    accent: "#6366f1",
  },
  {
    company: "Hacktoberfest'24",
    role: "Open Source Contributor",
    type: "Remote",
    duration: "Sept 2024 - Oct 2024",
    icon: <FaGithub className="experience-icon" />,
    highlights: [
      "Participated actively in the open-source community, making valuable contributions to multiple repositories.",
    ],
    accent: "#f97316",
  },
  {
    company: "Winter Of Blockchain",
    role: "Open Source Mentor",
    type: "Remote",
    duration: "Sep 2024 - Oct 2024",
    icon: <FaChalkboardTeacher className="experience-icon" />,
    highlights: [
      "Provided mentorship in blockchain technologies, assisting contributors with their projects and learning paths.",
    ],
    accent: "#14b8a6",
  },
  {
    company: "TimechainLabs",
    role: "Open Source Contributor",
    type: "Remote",
    duration: "Jun 2024 - Aug 2024",
    icon: <FaCode className="experience-icon" />,
    highlights: [
      "Focused on blockchain-related projects, contributing to smart contract development and decentralized applications.",
    ],
    accent: "#ef4444",
  },
  {
    company: "GirlScript Summer of Code (GSSoC'24)",
    role: "Open Source Contributor",
    type: "Remote",
    duration: "May 2024 - Aug 2024",
    icon: <FaCodeBranch className="experience-icon" />,
    highlights: [
      "Contributed to real-world projects, focusing on web development and software engineering best practices.",
    ],
    accent: "#a855f7",
  },
  {
    company: "Vinyasa Summer of Code (VSOC'24)",
    role: "Open Source Contributor",
    type: "Remote",
    duration: "Jun 2024 - Jul 2024",
    icon: <FaCodeBranch className="experience-icon" />,
    highlights: [
      "Developed new features and fixed bugs in various projects, gaining experience in a competitive coding environment.",
    ],
    accent: "#06b6d4",
  },
  {
    company: "Hacktoberfest'23",
    role: "Open Source Contributor",
    type: "Remote",
    duration: "Sept 2023 - Oct 2023",
    icon: <FaGithub className="experience-icon" />,
    highlights: [
      "Contributed to diverse open-source projects, enhancing skills in collaborative development and version control.",
    ],
    accent: "#10b981",
  },
];

function Experience() {
  const renderTimelineItems = (items) => {
    return items.map((exp, index) => (
      <div
        key={index}
        className={`timeline-item ${index % 2 === 0 ? "left" : "right"}`}
      >
        <div className="timeline-content glass-card">
          <div
            className="icon-container"
            style={{ color: exp.accent, background: `${exp.accent}20` }}
          >
            {exp.icon}
          </div>
          <div className="content-header">
            <h3 className="company-name" style={{ color: exp.accent }}>
              {exp.company}
            </h3>
            <div className="role-container">
              <h4 className="role">{exp.role}</h4>
              {exp.type && (
                <span
                  className="type"
                  style={{ background: `${exp.accent}25`, color: exp.accent }}
                >
                  {exp.type}
                </span>
              )}
            </div>
            <div className="duration">{exp.duration}</div>
          </div>
          {exp.highlights && exp.highlights.length > 0 && (
            <ul className="highlights">
              {exp.highlights.map((highlight, i) => (
                <li key={i} style={{ "--bullet-color": exp.accent }}>
                  {highlight}
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    ));
  };

  return (
    <Container fluid className="experience-section">
      <Container>
        <h1 className="section-heading text-center mb-4">
          Professional <strong className="purple">Experience</strong>
        </h1>

        <h2 className="sub-heading text-center mb-5">Internship Experiences</h2>
        <div className="timeline-container mb-5">
          {renderTimelineItems(internshipExperiences)}
        </div>

        <h2 className="sub-heading text-center mb-5">
          Open Source <strong className="purple">Experiences</strong>
        </h2>
        <div className="timeline-container">
          {renderTimelineItems(openSourceExperiencesData)}
        </div>
      </Container>
    </Container>
  );
}

export default Experience;
